import { render } from "./DefaultBlock.vue?vue&type=template&id=7cacf623&scoped=true"
import script from "./DefaultBlock.vue?vue&type=script&lang=js"
export * from "./DefaultBlock.vue?vue&type=script&lang=js"

import "./DefaultBlock.vue?vue&type=style&index=0&id=7cacf623&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cacf623"]])

export default __exports__